// (c) chaehongee. Confidential and proprietary.

import { cloneElement, isValidElement } from 'react'
import type { ReactElement, ReactNode } from 'react'
import styles from './PrimaryButton.module.css'

interface PrimaryButtonProps {
    onClick: () => void
    disabled?: boolean
    loading?: boolean
    icon?: ReactNode
    loadingIcon?: ReactNode
    children: ReactNode
    fullWidth?: boolean
    className?: string
}

export default function PrimaryButton(props: PrimaryButtonProps): ReactElement {
    const { onClick, disabled, loading, icon, loadingIcon, children, fullWidth, className } = props

    const renderIcon = (iconNode: ReactNode, addSpinner?: boolean) => {
        if (!iconNode) return null
        if (isValidElement(iconNode) && addSpinner) {
            return cloneElement(iconNode, { className: styles.spinner } as Record<string, unknown>)
        }
        return iconNode
    }

    return (
        <button
            onClick={onClick}
            disabled={disabled || loading}
            className={`${styles.button} ${fullWidth ? styles.fullWidth : ''} ${className || ''}`}
            data-loading={loading}
        >
            {loading ? renderIcon(loadingIcon, true) : renderIcon(icon)}
            <span>{children}</span>
        </button>
    )
}

